module.exports = __webpack_public_path__ + "img/VP-ProfiNew-Profiles.a3947171.jpg";